import { BaseDataChannel } from "./BaseDataChannel";
import { ObjectDetectionReport } from "./ObjectDetectionReport";

export class ObjectDetectionChannel extends BaseDataChannel {
  public detections = new ObjectDetectionReport();
  constructor() {
    super();
  }
  public onMessage(ev: MessageEvent): void {
    const data = ev.data as ArrayBuffer;
    const checkBuffer = new Uint8Array(data, 0, 1);
    // const robotActor = this.stateManager as RobotActor;
    // console.log('Received object detection data:', checkBuffer[0]);
    if (checkBuffer[0] === 0x00) {
      // remove the first byte
      // console.log({ data });
      const visualDetectionBuffer = new Int16Array(data.slice(1));
      this.detections.read(visualDetectionBuffer);
      const numDetections = this.detections.detectedObjects.length;
      const first = this.detections.detectedObjects[0];
      // if (first) {
      //   console.log('Obj distance:', first.distance, ' bearing:', first.bearing);
      // }
    } else if (checkBuffer[0] === 0x01) {
      const lidarLockBuffer = new Float64Array(data.slice(1));
      const x1 = lidarLockBuffer[0];
      const y1 = lidarLockBuffer[1];
      const z1 = lidarLockBuffer[2];
      const x2 = lidarLockBuffer[3];
      const y2 = lidarLockBuffer[4];
      const z2 = lidarLockBuffer[5];
      // robotActor.updateRobot({ lidarLockon: [x1, y1, z1, x2, y2, z2] });
      // console.log('Lidar lockon:', { x, y, z });
    } else {
      console.error('Unknown data type:', checkBuffer[0]);
    }
    this.emit("data", this.detections.detectedObjects);
  }
  public getConfiguration() {
    return {
      name: "object_detection",
    };
  }
  protected onConnected(): void { }
}